import { ThemeColors } from '@lessonPlanner/constants';
import { useCallback } from 'react';

const layoutImageCache: Record<string, string> = {};

export function clearLayoutImageCache(): void {
  Object.keys(layoutImageCache).forEach(key => {
    delete layoutImageCache[key];
  });
}

export function getLayoutBackgroundImage(theme: ThemeColors, layout?: string): string | undefined {
  if (!theme.layoutImages) {
    return undefined;
  }
  
  const layoutMapping: Record<string, string> = {
    'centeredfocus': 'centeredFocus',
    'leftcontent': 'leftContent',
    'rightcontent': 'rightContent'
  };
  
  const normalizedLayout = layout?.toLowerCase() || 'default';
  const layoutKey = layoutMapping[normalizedLayout] || normalizedLayout;
  
  const themeIdentifier = theme.background || '';
  const cacheKey = `${themeIdentifier}-${layoutKey}`;
  
  if (layoutImageCache[cacheKey]) {
    return layoutImageCache[cacheKey];
  }
  
  const layoutImages = theme.layoutImages[layoutKey];
  const defaultImages = theme.layoutImages['default'];
  const images = layoutImages || defaultImages || [];
  
  if (images.length > 0) {
    const selectedImage = images[Math.floor(Math.random() * images.length)];
    layoutImageCache[cacheKey] = selectedImage;
    return selectedImage;
  }
  
  return undefined;
}

export function useLayoutBackground() {
  const getBackgroundImage = useCallback(
    (theme: ThemeColors, layout?: string) => getLayoutBackgroundImage(theme, layout),
    []
  );

  const clearCache = useCallback(() => clearLayoutImageCache(), []);

  return {
    getLayoutBackgroundImage: getBackgroundImage,
    clearLayoutImageCache: clearCache
  };
} 